import React, { useEffect, useState, useContext } from "react";
import { SavedCardPciContainer, ShimmerCardLayout } from "PCI/assets/style";
import { PciSdkConfig, PciSdkTypes, PCI_IFRAME_IDS } from "PCI/utills";
import { useHistory } from "react-router-dom";
import {
  ListenMessage,
  LISTEN_MESSAGE_TYPE,
  PostMessage,
  POST_MESSAGE_TYPE,
} from "services/MessageService";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { get } from "../../logics/src/utils/helpers";
import { doCheckOffers } from "../../logics/src/utils/checkOffers";
import { toLowerCase } from "../../logics/src/utils/toLowerCase";
import { Theme } from "@nykaa/ui-components/themes/types";
import { useTheme } from "emotion-theming";
import { getPaymentOfferInfoConfig } from "../../logics/src/utils/helpers";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { PAYMENT_MODES } from "constants/paymentModes";
import { PAYMENT_TYPE } from "constants/payment";
import { PAYMENT_ERROR_MESSAGE } from "constants/paymentStatus";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { Modal } from "@nykaa/payment-ui/src/Modal";
import { allTrackingHandlerForApps } from "helpers/utils/trackingHandler";
import { doRedirect } from "helpers/utils/redirection";
import { DEVICE_TYPE, TRACKING_EVENTS } from "constants/index";
import { ShimmerRow } from "components/ShimmerRow/shimmer";
import { CLIENT_URLS } from "constants/urls";
import { PAYMENT_OPTION } from "constants/paymentScreens";

import PCI from "PCI";
import PaymentOfferInfo from "@nykaa/payment-sdk/src/PaymentOfferInfo/mobile";
import PaymentOfferInfoDesktop from "@nykaa/payment-sdk/src/PaymentOfferInfo/desktop";

export const SavedCardPci = ({
  pciPageLoadData,
  doPayment,
  deviceType,
  setLoading,
}: PciSdkConfig) => {
  const history = useHistory();
  const theme: Theme = useTheme();
  const paymentContext = useContext(PaymentContext);
  const { applicationData } = useContext(ApplicationContext);
  const errorModalContext = useContext(ErrorModalContext);

  const paymentInfo = get(paymentContext, "paymentInfo");
  const cartRules = get(paymentContext, "offersData");
  const openErrorModal = get(errorModalContext, "openErrorModal");
  const { isApp } = applicationData;
  const { cartInfo } = get(paymentContext, "cartInfo");
  const setPciOtpInfo = get(paymentContext, "setPciOtpInfo");
  const pciOtpScreenVisibleForSaved = get(paymentContext, "pciOtpScreenVisibleForSaved");
  const setPciOtpScreenVisibleForSaved = get(paymentContext, "setPciOtpScreenVisibleForSaved");
  const isWalletAccordianOpen = get(paymentContext, "isWalletAccordianOpen");
  const setIsWalletAccordianOpen = get(paymentContext, "setIsWalletAccordianOpen");
  const paymentAmount = get(pciPageLoadData, "paymentInfo.paymentAmount");
  const activeMethodForSavedPayments = get(paymentContext, "activeMethodForSavedPayments");
  const setActiveMethodForSavedPayments = get(paymentContext, "setActiveMethodForSavedPayments");
  const pciShimmerVisible = get(paymentContext, "pciShimmerVisible");
  const setPciShimmerVisible = get(paymentContext, "setPciShimmerVisible");
  const setPaymentOption = get(paymentContext, "setPaymentOption");
  
  const [savedCardHeight, setSavedCardHeight] = useState(188);
  const [offerConfig, setOfferConfig] = useState({});
  const [isOfferVisible, setIsOfferVisible] = useState(false);

  useEffect(() => {
    PostMessage(
      {
        messageEventName: POST_MESSAGE_TYPE.RELOAD,
        data: pciPageLoadData,
      },
      PCI_IFRAME_IDS.SC
    );
  }, [paymentAmount, cartRules]);

  const togglePaymentOfferDetails = (e: any, offerData: any) => {
    e?.preventDefault();
    e?.stopPropagation();
    setIsOfferVisible(false);
    setOfferConfig(previousOfferConfig => {
      return { ...previousOfferConfig, bottomSheetVisible: false, sideBarVisible: false };
    });
  };

  const doPaymentHandler = (orderParams: any) => {
    doPayment(PAYMENT_MODES.SAVED_CARD, orderParams?.values);
  };

  useEffect(() => {
    ListenMessage(LISTEN_MESSAGE_TYPE.INITIATE_LOAD_SC, res => {
      PostMessage(
        {
          messageEventName: POST_MESSAGE_TYPE.LOAD,
          data: pciPageLoadData,
        },
        PCI_IFRAME_IDS.SC
      );
      /**
       * on page Load if wallet is having sufficient balance
       * and wallet accordian open then close Iframe saved card
       */
      PostMessage(
        {
          messageEventName: POST_MESSAGE_TYPE.WALLET_ACCORDIAN,
          data: { isWalletOpen: isWalletAccordianOpen },
        },
        PCI_IFRAME_IDS.SC
      );
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.ERROR_MESSAGE, res => {
      setLoading(false);
      openErrorModal(PAYMENT_ERROR_MESSAGE.FAILED, "");
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.CREATE_ORDER_SAVED, orderParams => {
      doPaymentHandler(orderParams);
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.SHOW_OFFERS_BOTTOM_SHEET, offerDetailsParams => {
      const offerKeys = [offerDetailsParams?.offerKey];
      if (offerDetailsParams?.offerKey) {
        const offerData = doCheckOffers(
          false,
          toLowerCase(offerDetailsParams?.mode),
          cartRules,
          paymentInfo,
          offerKeys
        );
        if (offerData?.hasOffers) {
          const paymentOfferConfig = getPaymentOfferInfoConfig({
            offerData,
            theme,
            action: togglePaymentOfferDetails,
            deviceType: applicationData?.deviceType,
            isVisible: !isOfferVisible,
          });
          setOfferConfig(paymentOfferConfig);
        }
      }
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.INITIATE_PAYMENT_SAVED_CARD, res => {
      setPciOtpInfo(res);
      if (deviceType === DEVICE_TYPE.MOBILE) {
        doRedirect({
          url: CLIENT_URLS.PCI_OTP_PAGE,
          history,
          isClientRedirection: true,
        });
      } else {
        setPciOtpScreenVisibleForSaved(true);
      }
    });

    /**
     * This listen message is for when user selected the pci saved method
     */
    ListenMessage(LISTEN_MESSAGE_TYPE.ACCORDIAN_SC, res => {
      setActiveMethodForSavedPayments(res?.active);
      setPaymentOption(PAYMENT_OPTION.SAVED);
      // apps tracking on saved payment method click
      allTrackingHandlerForApps({
        event: TRACKING_EVENTS.PAYMENT_METHOD_CLICK,
        paymentMethod: PAYMENT_MODES.CREDIT_CARD,
        cartInfo,
        paymentInfo,
        isSavedPaymentMethod: true,
        isApp,
      });
    });

    /**
     * if user open saved_cc accordian then close wallet accordian
     */
    ListenMessage(LISTEN_MESSAGE_TYPE.CLOSE_WALLET, res => {
      setIsWalletAccordianOpen(false);
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.PCI_SHIMMER_HIDE, res => {
      setPciShimmerVisible(res.hideShimmer);
    });
  });

  useEffect(() => {
    ListenMessage(LISTEN_MESSAGE_TYPE.RESIZE_SC, setSavedCardHeight).then(cardHeight => {
      if (cardHeight) {
        setSavedCardHeight(cardHeight);
      }
    });
  }, [savedCardHeight]);

  useEffect(() => {
    /**
     * This postMessage fires when user selected the non-pci saved method
     * so that unchecked the saved method of pci
     */
    if (activeMethodForSavedPayments === PAYMENT_TYPE.NON_PCI) {
      PostMessage(
        {
          messageEventName: POST_MESSAGE_TYPE.ACCORDIAN_NON_PCI_SC,
          data: { active: PAYMENT_TYPE.NON_PCI },
        },
        PCI_IFRAME_IDS.SC
      );
    }
  }, [activeMethodForSavedPayments]);

  useEffect(() => {
    /**
     * This postmessage is to close saved_cc accordian if
     * wallet is open (Wallet sufficient balance case)
     */
    PostMessage(
      {
        messageEventName: POST_MESSAGE_TYPE.WALLET_ACCORDIAN,
        data: { isWalletOpen: isWalletAccordianOpen },
      },
      PCI_IFRAME_IDS.SC
    );
  }, [isWalletAccordianOpen]);

  const msite = () => {
    return (
      <>{Boolean(Object.keys(offerConfig)?.length) && <PaymentOfferInfo {...offerConfig} history={history}/>}</>
    );
  };

  const desktop = () => {
    return (
      <>
        {Boolean(Object.keys(offerConfig)?.length) && <PaymentOfferInfoDesktop {...offerConfig} />}

        {/* This consent sheet is for OTP screen Popup */}
        <Modal isVisible={pciOtpScreenVisibleForSaved} theme={theme}>
          <PCI paymentContext={paymentContext} sdkType={PciSdkTypes.OTP} setLoading={setLoading} />
        </Modal>
      </>
    );
  };


  if (!pciShimmerVisible && deviceType === DEVICE_TYPE.MOBILE) {
    return (
      <ShimmerCardLayout theme={theme}>
        <ShimmerRow margin="10px" width="90%" height="60px" />
        <ShimmerRow margin="10px" width="90%" height="60px" />
      </ShimmerCardLayout>
    );
  }

  return (
    <>
      <SavedCardPciContainer
        height={`${savedCardHeight}px`}
        id={PCI_IFRAME_IDS.SC}
        sandbox="allow-scripts allow-forms allow-top-navigation allow-same-origin allow-orientation-lock allow-pointer-lock"
        src={`${process.env.PCI_ORIGIN}/sc`}
      />
      {deviceType === DEVICE_TYPE.DESKTOP ? desktop() : msite()}
    </>
  );
};
